<footer>
  <div class="main-width">
    <div class="top-footer">
      <ul>
        <li>
          <div class="footer-item">
            <h3>عن سبيرو</h3>
            <ul class="footer-list">
              <li><a routerLink="/workshop-application">سبيرو للورش و الشركات</a></li>
              <li><a routerLink="/about-us">من نحن</a></li>
              <li><a href="#">الشركاء</a></li>
              <li><a href="https://airtable.com/shrMT6rA4nL5A1ZTH" target="_blank">انضم الينا</a></li>
            </ul>
          </div>
        </li>
        <li>
          <div class="footer-item">
            <h3>اعرف اكثر</h3>
            <ul class="footer-list">
              <li><a routerLink="/paid-quotation">خدمة التسعير المدفوع</a></li>
              <li><a href="https://support.speero.net" target="_blank">الاسئلة الشائعة</a></li>
              <li><a href="https://support.speero.net" target="_blank">مركز خدمة العملاء</a></li>
              <li><a href="https://speero.workable.com">انضم الى فريق العمل</a></li>
            </ul>
          </div>
        </li>
        <li>
          <div class="footer-item">
            <h3>قبل أن تبدأ</h3>
            <ul class="footer-list">
              <li><a routerLink="/paid-quotation">خدمة التسعير المدفوع</a></li>
              <li><a routerLink="/privacy-policy">سياسة الخصوصية</a></li>
              <li><a routerLink="/terms-and-conditions">الشروط والأحكام</a></li>
              <li><a routerLink="/payment-methods">طرق الدفع</a></li>
            </ul>
          </div>
        </li>
        <li>
          <div class="footer-item">
            <h3>اتصل بنا</h3>
            <ul class="footer-list">
              <li>مركز الوسط التجاري - الرياض</li>
            </ul>
            <ul class="footer-list">
              <li>
                <h3>مواعيد العمل</h3>
                <span>09:00AM - 06:00PM</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <div class="footer-sponsor main-width">
    <div class="payment-methods">
      <a target="_blank" href="https://maroof.sa/25727"><img src="/public/resources/images/maroof.png" /></a>

      <img src="/public/resources/images/visa.svg" title="بطاقة فيزا الائتمانية" />
      <img src="/public/resources/images/mastercard.svg" title="بطاقة ماستر كارد
        الائتمانية" />
      <img src="/public/resources/images/mada-footer.svg" title="بطاقة مدى" />
    </div>
    <div class="footer-social">
      <a href="https://www.twitter.com/speerosa" class="twitter" title="تابعنا
        على تويتر" target="_blank"></a>
      <a href="https://www.instagram.com/speerosa" class="instagram" title="تابعنا على انستقرام" target="_blank"></a>
    </div>
  </div>
  <div class="footer-manufacturers">
    <div class="footer-manufacturers-widget" *ngIf="carData">
      <div class="main-width">
        <h2>أكثر موديلات {{ _carData.models[0].manufactureId.nameArabic }} طلبا</h2>
      </div>
      <div class="footer-manufacturers-widget__item">
        <div class="main-width">
          <div class="item-names pull-left">
            <a *ngFor="let model of subdomainCars.modelsIds"
              href="{{ appURL }}/-قطع-غيار{{ subdomainCars.nameArabic }}/{{ model.nameArabic }}">{{ model.nameArabic }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-manufacturers-widget">
      <div class="main-width">
        <h2>أكثر ماركات السيارة طلبا</h2>
      </div>
      <div class="footer-manufacturers-widget__item" *ngFor="let manufacture of manufactureList; let i = index">
        <div class="main-width">
          <div class="item-footer">
            <div class="item-title">
              <a href="{{ appURL }}/قطع-غيار-{{ manufacture.nameArabic | lowercase }}"
                title="قطع غيار سيارات {{ manufacture.nameArabic }}">
                <img *ngIf="manufacture._id"
                  src="/public/resources/images/cars/{{ manufacture.nameEnglish | lowercase }}-colored.svg"
                  alt="{{ manufacture.nameEnglish }}" />
              </a>
            </div>
            <div class="item-names">
              <a *ngFor="let model of manufacture.modelsIds"
                href="{{ appURL }}/قطع-غيار-{{ manufacture.nameArabic }}/{{ model.nameArabic }}">{{ model.nameArabic }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
